<div class="mx-auto flex w-full max-w-4xl min-w-0 flex-col gap-4" data-testid="hyperion-run-page">
    <jhi-hyperion-run-header
        [exerciseId]="exerciseId()"
        [jobId]="jobId()"
        [exerciseTitle]="exercise()?.title"
        [adapting]="adapting()"
        [variant]="variant()"
        [metaLabelKeys]="metaLabelKeys()"
        [statusState]="statusDotState()"
        [statusLabelKey]="statusLabelKey()"
        [startedAt]="startedAt()"
        [endedAt]="endedAt()"
        [terminal]="terminal()"
        [ownedByCaller]="ownedByCaller()"
        [cancelAvailable]="cancelAvailable()"
        [cancelPending]="cancelRequested()"
        [editorLink]="terminal() && !running() ? editorLink() : undefined"
        [exerciseLink]="exerciseLink()"
        [stepPosition]="showStepCounter() ? stepPosition() : undefined"
        [stepTotal]="stepTotal"
        [spend]="spend()"
        [fileCount]="fileCount()"
        (cancelRequested)="cancel($event)"
    />

    @if (ownedByCaller() && runInput(); as context) {
        <jhi-hyperion-run-input [context]="context" [adapting]="adapting()" [collapsed]="true" />
    }

    @if (canRevert() || reverting()) {
        <tumaet-ui-button severity="secondary" variant="outlined" [disabled]="reverting()" (clicked)="confirmRevert()" data-testid="hyperion-run-undo">
            {{ 'artemisApp.hyperion.generationActivity.' + (reverting() ? 'reverting' : undoKey()) | artemisTranslate }}
        </tumaet-ui-button>
    }
    @if (reverted()) {
        <tumaet-ui-message severity="success" data-testid="hyperion-run-undone">
            {{ 'artemisApp.hyperion.generationActivity.' + undoKey() + 'Success' | artemisTranslate }}
        </tumaet-ui-message>
    }
    @if (revertPartialRepositories(); as repositories) {
        <tumaet-ui-message severity="error" data-testid="hyperion-run-undo-partial">
            {{ 'artemisApp.hyperion.generationActivity.revertPartialFailed' | artemisTranslate: { repositories } }}
        </tumaet-ui-message>
    }

    @if (statusLoadFailed()) {
        <tumaet-ui-message severity="error" class="block" data-testid="hyperion-run-status-unavailable">
            <div class="flex min-w-0 flex-col gap-2">
                <span jhiTranslate="artemisApp.hyperion.generation.run.statusUnavailable"></span>
                @if (running()) {
                    <span class="text-sm" jhiTranslate="artemisApp.hyperion.generation.run.stillRunningOnServer"></span>
                }
                <div class="flex flex-wrap items-center gap-3">
                    @if (lastUpdateTime(); as time) {
                        <span class="text-sm" data-testid="hyperion-run-last-update">{{ 'artemisApp.hyperion.generation.run.lastUpdate' | artemisTranslate: { time } }}</span>
                    }
                    <tumaet-ui-button size="small" severity="secondary" variant="outlined" (clicked)="retryStatus()" data-testid="hyperion-run-status-retry">
                        <span jhiTranslate="artemisApp.hyperion.generation.run.retryStatus"></span>
                    </tumaet-ui-button>
                </div>
            </div>
        </tumaet-ui-message>
    }

    @if (notStarted() || historyExpired()) {
        <tumaet-ui-card data-testid="hyperion-run-not-started">
            <div class="flex items-center justify-between gap-3">
                <h2 class="text-xl font-medium">{{ idleTitleKey() | artemisTranslate }}</h2>
            </div>
            <p class="m-0 text-sm" [jhiTranslate]="idleHintKey()"></p>
        </tumaet-ui-card>
    } @else {
        @if (outcomeView(); as view) {
            <tumaet-ui-card>
                <jhi-hyperion-run-outcome [view]="view" />
                <tumaet-ui-panel
                    class="mt-3 block"
                    toggleable
                    [collapsed]="true"
                    [header]="stageStripHeaderKey() | artemisTranslate: stageStripHeaderParams()"
                    data-testid="hyperion-run-stage-strip"
                >
                    <jhi-hyperion-run-progress
                        [stages]="stages()"
                        [adapting]="adapting()"
                        [liveMessage]="liveMessage()"
                        [repairRound]="repairRound()"
                        [activity]="activityView()"
                    />
                </tumaet-ui-panel>
            </tumaet-ui-card>
        } @else {
            <!-- Keep projected headers outside control-flow blocks within the card. -->
            <tumaet-ui-card>
                <div class="flex items-center justify-between gap-3">
                    <h2 class="text-xl font-medium" id="hyperion-run-progress-title">{{ 'artemisApp.hyperion.generation.run.progressTitle' | artemisTranslate }}</h2>
                    <div class="flex items-center gap-2">
                        @if (showStepCounter() && stepPosition(); as position) {
                            <span class="text-sm tabular-nums text-muted-color" data-testid="hyperion-run-step-counter">{{
                                'artemisApp.hyperion.generation.run.stepCounter' | artemisTranslate: { position, total: stepTotal }
                            }}</span>
                        }
                    </div>
                </div>
                <section class="mt-3" aria-labelledby="hyperion-run-progress-title">
                    <jhi-hyperion-run-progress
                        [stages]="stages()"
                        [adapting]="adapting()"
                        [liveMessage]="liveMessage()"
                        [repairRound]="repairRound()"
                        [activity]="activityView()"
                        [cancelAvailable]="cancelAvailable()"
                        [cancelPending]="cancelRequested()"
                        [connected]="connected()"
                        (cancelRequested)="cancel()"
                    />
                </section>
            </tumaet-ui-card>
        }

        <tumaet-ui-card>
            <jhi-hyperion-artifacts
                [jobId]="jobId()"
                [specDocument]="specDocument()"
                [adapting]="adapting()"
                [variant]="variant()"
                [savedToExercise]="savedToExercise()"
                [files]="fileChanges()"
                [running]="running()"
                [terminal]="terminal()"
            />
        </tumaet-ui-card>

        @if (spend(); as spendView) {
            <section class="hyperion-run-detail pt-4">
                <jhi-hyperion-run-usage [spend]="spendView" [sealedAt]="endedAt()" />
            </section>
        }
    }
</div>

<tumaet-ui-dialog
    [header]="'artemisApp.hyperion.generationActivity.' + undoKey() + 'ConfirmHeader' | artemisTranslate"
    [visible]="confirmRevertVisible()"
    (visibleChange)="dismissRevert()"
    size="small"
>
    <p>{{ 'artemisApp.hyperion.generationActivity.' + undoKey() + 'ConfirmMessage' | artemisTranslate }}</p>
    <div tumAetUiDialogFooter class="flex justify-end gap-2">
        <tumaet-ui-button severity="secondary" variant="outlined" (clicked)="dismissRevert()">
            <span jhiTranslate="entity.action.cancel"></span>
        </tumaet-ui-button>
        <tumaet-ui-button severity="danger" (clicked)="acceptRevert()" data-testid="hyperion-run-undo-confirm">
            {{ 'artemisApp.hyperion.generationActivity.' + undoKey() | artemisTranslate }}
        </tumaet-ui-button>
    </div>
</tumaet-ui-dialog>
